import React, {useEffect, useState} from 'react';
import logo_sharecare1 from '../../assets/logo_sharecare1.png';

export const HoraSeleccionar = (props) => {
  const { hora, changeHora, fechaSeleccionada } = props;

  //console.log(fechaSeleccionada)

  const fecha_actual = new Date();
  const hora_actual = `${fecha_actual.getHours().toString().padStart(2, '0')}:${fecha_actual.getMinutes().toString().padStart(2, '0')}`;
  const fechaSeleccionadaDate = new Date(fechaSeleccionada);


  // Función para convertir una hora string a minutos totales desde medianoche
  const convertirHoraAMinutos = (horaStr) => {
    const [horas, minutos] = horaStr.split(':').map(Number);
    return horas * 60 + minutos;
  };

  // Convertimos las horas a minutos totales para comparar
  const minutosHoraActual = convertirHoraAMinutos(hora_actual);
  const minutosHora = convertirHoraAMinutos(hora.hora);

  // Comprobar si la fecha seleccionada es hoy
  const esHoy = fechaSeleccionadaDate && fechaSeleccionadaDate.toDateString() === fecha_actual.toDateString();

  // Filtramos las horas pasadas solo si la fecha seleccionada es hoy
  const horaValida = !esHoy || (esHoy && minutosHora >= minutosHoraActual);
		
  useEffect(()=>{
    console.log(horaValida)
  })

  return (
    horaValida && (
      <div className={hora.estado || minutosHora < minutosHoraActual ? 'hora-perfil-empresa' : 'hora-perfil-empresa espcia-hora'}>
        {!hora.estado && (
          <div
            className='centrador hora-empresa'
            onClick={() => changeHora(hora)}
          >
            {hora.shareCare ? (
              <>
                <div className='centrador hora-hora-selecionada'>{hora.hora}</div>
                <div className='centrador imagen-hora-selecionada'>
                  <img src={logo_sharecare1} alt="Sharecare Logo" />
                </div>
              </>
            ) : (
              <div>{hora.hora}</div>
            )}
          </div>
        )}
        {hora.estado && (
          <>
            <div className='centrador hora-empresaActive'>
              {hora.shareCare ? (
                <>
                  <div className='centrador hora-hora-selecionada'>{hora.hora}</div>
                  <div className='centrador imagen-hora-selecionada'>
                    <img src={logo_sharecare1} alt="Sharecare Logo" />
                  </div>
                </>
              ) : (
                <div>{hora.hora}</div>
              )}
            </div>
          </>
        )}
      </div>
    )
  );
};
